import { render, staticRenderFns } from "./InputBreak.vue?vue&type=template&id=474e4ef9"
import script from "./InputBreak.vue?vue&type=script&lang=js"
export * from "./InputBreak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports